import {
    buildAppDataFromRetentionState,
    buildMwSettings,
    buildRequestBody,
    executeRetentionPipelines,
    getInitialState,
    transformInsightsResponse,
    wrapMwResultsAsArtifact,
} from './retention-trends.utils.js';
import { getAppId } from '@/vuex/modules/trends/trends-settings.module.js';

const retentionTrends = {
    namespaced: true,
    state: getInitialState(),
    mutations: {
        setRetentionInsights (state, { insights }) {
            state.insights = insights;
        },
        setInsightRequestBody (state, { requestBody }) {
            state.insightRequestBody = requestBody;
        },
        setLoading (state, { isLoading }) {
            state.isLoading = isLoading;
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async fetchRetentionInsights ({ commit, rootGetters }) {
            commit('setLoading', { isLoading: true });
            commit('setError', { error: null });

            try {
                const appId = await getAppId(rootGetters);
                const includeAnonymous = false;

                const requestBody = buildRequestBody(appId, includeAnonymous, rootGetters);
                commit('setInsightRequestBody', { requestBody });

                const settings = buildMwSettings(appId, includeAnonymous, rootGetters);
                const executed = await executeRetentionPipelines(settings);
                const synthetic = wrapMwResultsAsArtifact(appId, executed);

                const appData = buildAppDataFromRetentionState(synthetic, rootGetters, appId);
                const transformed = transformInsightsResponse(synthetic, appData);

                commit('setRetentionInsights', { insights: transformed });

                return transformed;
            } catch (error) {
                commit('setError', { error: error.message || 'Failed to fetch retention insights' });
                throw error;
            } finally {
                commit('setLoading', { isLoading: false });
            }
        },
    },
    getters: {
        retentionInsights: (state) => state.insights || [],
        insightRequestBody: (state) => state.insightRequestBody,
        isLoading: (state) => state.isLoading,
        hasError: (state) => !!state.error,
        error: (state) => state.error,
    },
};

export default retentionTrends;
